<div
  *ngIf="
    hoursdata?.days?.length || hoursdata?.generic_weekend || hoursdata?.extended
  "
>
  <div class="heading">{{ translations.hours }}</div>
  <div class="heading-break" fxHide.gt-md></div>
  <ul>
    <li
      *ngFor="let day of hoursdata?.days"
      fxLayout="row"
      fxLayout.lt-md="column"
    >
      <span fxFlex="40" class="text-medium">{{ translations[day.name] }}:</span>
      <span fxFlex="60">{{ day.formatted }}</span>
    </li>
  </ul>
  <div *ngIf="hoursdata?.generic_weekend">
    <div>
      <i class="material-icons pull-left" aria-hidden="true">check</i>
      <span>{{ translations.weekendHours }}</span>
    </div>
  </div>
  <div *ngIf="hoursdata?.extended">
    <div>
      <i class="material-icons pull-left" aria-hidden="true">check</i>
      <span>{{ translations.extendedHours }}</span>
    </div>
  </div>
</div>
